import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { creditosAPI } from '../../services/api';

// Thunks para operaciones asíncronas
export const fetchCreditsByOrder = createAsyncThunk(
  'credits/fetchCreditsByOrder',
  async (pedidoId, { rejectWithValue }) => {
    try {
      const { data } = await creditosAPI.getByPedidoId(pedidoId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Error al obtener créditos');
    }
  }
);

export const createCredit = createAsyncThunk(
  'credits/createCredit',
  async (creditData, { rejectWithValue }) => {
    try {
      const { data } = await creditosAPI.create(creditData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Error al crear crédito');
    }
  }
);

export const updateCredit = createAsyncThunk(
  'credits/updateCredit',
  async ({ id, creditData }, { rejectWithValue }) => {
    try {
      const { data } = await creditosAPI.update(id, creditData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Error al actualizar crédito');
    }
  }
);

export const deleteCredit = createAsyncThunk(
  'credits/deleteCredit',
  async (id, { rejectWithValue }) => {
    try {
      await creditosAPI.delete(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.message || 'Error al eliminar crédito');
    }
  }
);

const creditsSlice = createSlice({
  name: 'credits',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearCredits: (state) => {
      state.items = [];
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch credits by order
      .addCase(fetchCreditsByOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCreditsByOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCreditsByOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create credit
      .addCase(createCredit.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCredit.fulfilled, (state, action) => {
        state.loading = false;
        state.items.push(action.payload);
      })
      .addCase(createCredit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update credit
      .addCase(updateCredit.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCredit.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.items.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(updateCredit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete credit
      .addCase(deleteCredit.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCredit.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.filter(item => item.id !== action.payload);
      })
      .addCase(deleteCredit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCredits, clearError } = creditsSlice.actions;

// Selectors
export const selectAllCredits = (state) => state.credits.items;
export const selectCreditsLoading = (state) => state.credits.loading;
export const selectCreditsError = (state) => state.credits.error;

export default creditsSlice.reducer;
